// src/services/admin/admin-reviewService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

const adminReviewApi = axios.create({
  baseURL: `${API_URL}/api/v1/admin/reviews`,   // 👈 admin mount point
  headers: { 'Content-Type': 'application/json' },
  timeout: 15000
});

// Use the admin token here
adminReviewApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('adminToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

const adminReviewService = {
  async getReviews(params = {}) {
    const res = await adminReviewApi.get('/', { params }); // 👈 list is now '/'
    return res.data;
  },

  async getReviewStats() {
    const res = await adminReviewApi.get('/stats');
    return res.data;
  },

  async getReviewById(id) {
    const res = await adminReviewApi.get(`/${id}`);
    return res.data;
  },

  async moderateReview(id, status, moderationNote = '') {
    const res = await adminReviewApi.patch(`/${id}/moderate`, {
      status,
      moderationNote
    });
    return res.data;
  },

  async deleteReview(id) {
    const res = await adminReviewApi.delete(`/${id}`);
    return res.data;
  },

  getStatusBadgeConfig(status) {
    const configs = {
      pending:  { bgColor: 'bg-[#FFF4D6]', textColor: 'text-[#D8A100]', dotColor: 'bg-[#D8A100]' },
      approved: { bgColor: 'bg-[#E7F4ED]', textColor: 'text-[#2F8F5B]', dotColor: 'bg-[#2F8F5B]' },
      rejected: { bgColor: 'bg-[#F4E7E7]', textColor: 'text-[#A82121]', dotColor: 'bg-[#A82121]' },
      spam:     { bgColor: 'bg-gray-100',  textColor: 'text-gray-700',  dotColor: 'bg-gray-500' }
    };
    return configs[status] || configs.pending;
  },

  formatDate(dateString) {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  }
};

export default adminReviewService;